import {h, Fragment} from "preact"
import { useAppStateSelector } from "@nosto/preact"
import SelectedFilters from './SelectedFilters'
import Toolbar from './Toolbar'
import Sidebar from "./Sidebar"

/**
 * ContentWrapper takes a function to render non-empty results in the content area.
 * On loading the Loader is used and for empty results the NoResults component is used.
 */
function ContentWrapper({ type, children }) {
    const {
        foundProducts,
        loading,
        pageType,
        query,
        docCount
    } = useAppStateSelector(state => ({
        foundProducts: state.response.products?.total > 0, 
        loading: state.loading,
        pageType: state.pageType,
        query: state?.query,
        docCount: state?.response?.products?.total ?? 0
     }))

    return (
        <div class="ns-serp ns-d-flex ns-flex-column ns-flex-md-row ns-font-inherit ns-pt-4 ns-pb-4 ns-my-0 ns-mx-auto"
            data-nosto-element={type}>
            {(pageType === "search" && foundProducts) && (<>
                {docCount && (
                    <h2 class="h3 ns-color-grey-medium text-center italic ns-col-12 ns-mb-n4 search-result-title" style={loading ? "opacity: 0.3;" : ""}>
                        <span class="search-title-inner">{docCount} results of <span class="ns-color-swing-red">{query.query}</span></span>
                    </h2> 
                )}

                <div class="ns-d-flex ns-flex-wrap ns-flex-column ns-flex-sm-row ns-align-items-center ns-justify-content-between ns-mb-n4 ns-w-100 ns-border-box search-header-middle" style={loading ? "opacity: 0.3;" : ""}>
                    <SelectedFilters />
                    <Toolbar />
                </div>


            </>)}
            {foundProducts && <Sidebar />}
            <div
                class="ns-product-listing-wrapper ns-flex-wrap ns-align-items-center ns-justify-content-between ns-w-100 ns-border-box ns-pl-md-5 ns-p-0 ns-col"
                style={{ position: loading ? "relative" : "initial" }}>
                { children({ loading, foundProducts }) }
            </div>
        </div>
    )
}

export function wrapContent(type, Component) {
    return () => (<ContentWrapper type={type}>{Component}</ContentWrapper>)
}

